"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHMenuEntrySelectV3 = exports.SelectDirection = void 0;
const KHMenuEntryV3_1 = require("./KHMenuEntryV3");
var SelectDirection;
(function (SelectDirection) {
    SelectDirection[SelectDirection["Horizontal"] = 0] = "Horizontal";
    SelectDirection[SelectDirection["Vertical"] = 1] = "Vertical";
})(SelectDirection || (exports.SelectDirection = SelectDirection = {}));
class KHMenuEntrySelectV3 extends KHMenuEntryV3_1.KHMenuGenericEntryV3 {
    constructor(config) {
        const selectPrevious = () => {
            this.setSelectedIdx(this.selectedIdx - 1);
        };
        const selectNext = () => {
            this.setSelectedIdx(this.selectedIdx + 1);
        };
        config = Object.assign(Object.assign({}, config), { leftCallback: config.selectDirection === SelectDirection.Horizontal ? selectPrevious : undefined, rightCallback: config.selectDirection === SelectDirection.Horizontal ? selectNext : undefined, upCallback: config.selectDirection === SelectDirection.Vertical ? selectNext : undefined, downCallback: config.selectDirection === SelectDirection.Vertical ? selectPrevious : undefined });
        super(config);
        this.config = config;
        this.selectedIdx = isNaN(Number(config.defaultIdx)) ? 0 : Number(config.defaultIdx);
    }
    lockAt(idx, reason) {
        if (this.locked)
            return;
        this.lockReason = reason;
        this.setSelectedIdx(idx, false);
        this.locked = true;
    }
    getDescription() {
        const idx = this.selectedIdx;
        const selection = this.config.options[idx];
        return this.config.descriptionGetter ? this.config.descriptionGetter(this, idx, selection) : selection.description;
    }
    getSelected() {
        return this.config.options[this.selectedIdx];
    }
    setSelectedIdx(idx, userInitiated = true) {
        if (this.locked)
            return;
        idx = (idx + this.config.options.length) % this.config.options.length;
        this.selectedIdx = idx;
        const selection = this.config.options[idx];
        let descriptionText = selection.description;
        this.setDescription(descriptionText);
        this.setLocked(this.lockReason != null);
        this.emitEvent('updatedSelectedOption', { userInitiated: userInitiated, menuEntry: this, index: idx, selection });
        this.emitEvent('description_updated', { text: this.getDescription() });
    }
}
exports.KHMenuEntrySelectV3 = KHMenuEntrySelectV3;
